import _regeneratorRuntime from "babel-runtime/regenerator";

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { Close } from "../../../Misc/Icons";
import { consumeContext } from "../../EditorContext";
import UploadButton from "./UploadButton";

var Filter = function Filter(_ref) {
  var title = _ref.title,
      isActive = _ref.isActive,
      onClick = _ref.onClick;
  return React.createElement("button", {
    className: "recorder__tabs-button " + (isActive ? "is-active" : null),
    onClick: onClick
  }, title);
};

var Filters = function (_React$Component) {
  _inherits(Filters, _React$Component);

  function Filters() {
    var _temp, _this, _ret;

    _classCallCheck(this, Filters);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.makeApplyFilterCallback = function (filter, value) {
      return function () {
        return _this.props.EditorContext.assets.applyFilter(filter, value);
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Filters.prototype.componentDidMount = function componentDidMount() {
    var _props$EditorContext = this.props.EditorContext,
        state = _props$EditorContext.state,
        assets = _props$EditorContext.assets;
    var _state$assets$assetsF = state.assets.assetsFilters,
        assetsFilters = _state$assets$assetsF === undefined ? [] : _state$assets$assetsF;

    if (assetsFilters.length > 0) {
      assets.applyFilter(assetsFilters[0].filter, assetsFilters[0].value);
    }
  };

  Filters.prototype.render = function render() {
    var _this2 = this;

    var _props$EditorContext2 = this.props.EditorContext,
        applyFilter = _props$EditorContext2.assets.applyFilter,
        _props$EditorContext3 = _props$EditorContext2.state.assets,
        _props$EditorContext4 = _props$EditorContext3.assetsFilters,
        assetsFilters = _props$EditorContext4 === undefined ? [] : _props$EditorContext4,
        appliedFilter = _props$EditorContext3.appliedFilter,
        appliedSearchTerm = _props$EditorContext3.appliedSearchTerm;
    var assetsUploader = appliedFilter ? assetsFilters.reduce(function (result, assetFilter) {
      return assetFilter.filter === appliedFilter.filter ? assetFilter.uploadAssets : result;
    }, null) : null;
    return React.createElement("div", {
      className: "recorder__tabs"
    }, assetsFilters.map(function (_ref2) {
      var title = _ref2.title,
          filter = _ref2.filter,
          value = _ref2.value;
      return React.createElement(Filter, {
        key: filter,
        title: title,
        isActive: appliedFilter && appliedFilter.filter === filter,
        onClick: _this2.makeApplyFilterCallback(filter, value)
      });
    }), React.createElement(Filter, {
      title: "All",
      isActive: !appliedFilter,
      onClick: this.makeApplyFilterCallback()
    }), this.supportSearch && React.createElement("div", {
      className: ["assets-search", appliedSearchTerm ? "active" : ""].filter(function (val) {
        return !!val;
      }).join(" ")
    }, React.createElement("input", {
      placeholder: "search",
      value: appliedSearchTerm || "",
      onChange: function onChange(e) {
        return _this2.props.EditorContext.assets.applySearch(e.target.value);
      }
    }), React.createElement("a", {
      className: "clear-search",
      onClick: function onClick(e) {
        e.preventDefault();

        _this2.props.EditorContext.assets.applySearch("");
      }
    }, React.createElement(Close, null))), assetsUploader && React.createElement(UploadButton, {
      assetsUploader: function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee(assets) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return assetsUploader(assets);

                case 2:
                  applyFilter(appliedFilter.filter, appliedFilter.value);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }()
    }));
  };

  _createClass(Filters, [{
    key: "supportSearch",
    get: function get() {
      var _props$EditorContext$ = this.props.EditorContext.state.assets,
          _props$EditorContext$2 = _props$EditorContext$.assetsFilters,
          assetsFilters = _props$EditorContext$2 === undefined ? [] : _props$EditorContext$2,
          appliedFilter = _props$EditorContext$.appliedFilter,
          supportSearch = _props$EditorContext$.supportSearch;
      return appliedFilter ? assetsFilters.reduce(function (result, assetFilter) {
        return assetFilter.filter === appliedFilter.filter ? assetFilter.supportSearch : result;
      }, false) : supportSearch;
    }
  }]);

  return Filters;
}(React.Component);

Filters.propTypes = process.env.NODE_ENV !== "production" ? {
  EditorContext: PropTypes.object.isRequired
} : {};
export default consumeContext(Filters);